import React from "react";
import { Box } from "@mui/material";
import styles from "./addGroupComponent.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import i18next from "i18next";
import { useFormikContext } from "formik";

const GroupFormComponent = () => {
  const formikProps = useFormikContext();
  return (
    <Box className={styles.addGroupInputWrapper} data-testid="GroupFormSection">
      <Box className="textboxDoubleWraper ">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Group name")}
          id="group_Name"
          name="group_Name"
          placeholder={i18next.t("Enter the group name")}
          onChange={(e) => {
            formikProps?.setFieldTouched("group_Name", false);
            formikProps?.setFieldValue("group_Name", e.target.value);
          }}
          value={formikProps?.values.group_Name}
          error={
            !!(formikProps?.touched.group_Name && formikProps?.errors.group_Name)
          }
          errorMessage={formikProps?.errors.group_Name}
        />
      </Box>
      <Box className="textboxDoubleWraper ">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Contact email - Optional")}
          id="group_email_id"
          name="group_email_id"
          placeholder={i18next.t("Enter the contact email")}
          onChange={(e) => {
            formikProps?.setFieldTouched("group_email_id", false);
            formikProps?.setFieldValue("group_email_id", e.target.value);
          }}
          value={formikProps?.values.group_email_id}
          error={
            !!(formikProps?.touched.group_email_id &&
            formikProps?.errors.group_email_id)
          }
          errorMessage={formikProps?.errors.group_email_id}
        />
      </Box>
      <Box className="textboxDoubleWraper ">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("City(headquarters) - Optional")}
          id="group_City"
          name="group_City"
          placeholder={i18next.t("Enter the head quarters city")}
          onChange={(e) => {
            formikProps?.setFieldTouched("group_City", false);
            formikProps?.setFieldValue("group_City", e.target.value);
          }}
          value={formikProps?.values.group_City}
          error={
            !!(formikProps?.touched.group_City && formikProps?.errors.group_City)
          }
          errorMessage={formikProps?.errors.group_City}
        />
      </Box>
    </Box>
  );
};

export default GroupFormComponent;
